import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const CURRENCIES = { USD: "$", INR: "₹", EUR: "€", GBP: "£" };

export const WAGE_COMPONENTS = [
  ["basic_wages", "Basic Wages"], ["fixed_overtime", "Fixed Overtime"], ["leave_wages", "Leave Wages"], ["bonus", "Bonus"],
  ["uniform_allowance", "Uniform Allowance"], ["performance_bonus", "Performance Bonus"],
  ["superior_certificate_allowance", "Superior Certificate Allowance"], ["old_tonnage_allowance", "Old Tonnage Allowance"],
  ["pension_pf", "Pension/PF"], ["special_allotment", "Special Allotment"], ["other_allowance", "Other Allowance"],
];

export const EMPTY_WAGES = Object.fromEntries(WAGE_COMPONENTS.map(([k]) => [k, ""]));

export const formatMoney = (currency, n) =>
  `${CURRENCIES[currency] || ""}${Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const wagesTotal = (wages) => Object.values(wages).reduce((s, v) => s + (v === "" || v == null ? 0 : Number(v) || 0), 0);

export function SeaWages({ currency, wages, onCurrency, onWages }) {
  const sym = CURRENCIES[currency];
  return (
    <div className="border border-slate-200 rounded-lg overflow-hidden" data-testid="sea-wages-block">
      <div className="flex flex-wrap items-center justify-between gap-3 px-4 py-3 bg-slate-50 border-b border-slate-200">
        <div className="text-sm font-semibold text-slate-800">Wages (per month)</div>
        <Select value={currency} onValueChange={onCurrency}>
          <SelectTrigger className="h-8 w-32 bg-white" data-testid="sea-currency-select"><SelectValue /></SelectTrigger>
          <SelectContent>
            {Object.entries(CURRENCIES).map(([c, s]) => <SelectItem key={c} value={c} data-testid={`sea-currency-option-${c}`}>{s} {c}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      <div className="divide-y divide-slate-100">
        {WAGE_COMPONENTS.map(([k, label]) => (
          <div key={k} className="flex items-center justify-between gap-3 px-4 py-2">
            <Label htmlFor={`wage-${k}`} className="text-sm text-slate-700 font-normal">{label}</Label>
            <div className="relative w-36 sm:w-44 shrink-0">
              <span className="absolute left-3 top-1/2 -translate-y-1/2 text-sm text-slate-400">{sym}</span>
              <Input id={`wage-${k}`} type="number" min="0" step="0.01" inputMode="decimal" value={wages[k]} placeholder="—"
                onChange={(e) => onWages({ ...wages, [k]: e.target.value })} className="pl-7 text-right font-mono h-9 [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none" data-testid={`sea-wage-${k}-input`} />
            </div>
          </div>
        ))}
      </div>
      <div className="flex items-center justify-between px-4 py-3 bg-[#0b192c] text-white">
        <span className="text-sm font-semibold">Total Per Month</span>
        <span className="font-mono font-semibold" data-testid="sea-wages-total">{formatMoney(currency, wagesTotal(wages))} {currency}</span>
      </div>
    </div>
  );
}
